import { Wrapper, StyledCard } from './OurMission.styles';
import Container from '@components/common/Container';

export default function OurMission() {
  return (
    <Container>
      <Wrapper>
        <StyledCard>
          <h3>Our Mission</h3>
          <h4>Unlock sustainable, long-term, and accessible opportunities for all</h4>
        </StyledCard>
      </Wrapper>
    </Container>
  );
}
